<template>
  <RootModalComponent
    :name="$MODAL_NAME.CHANGE_LANGUAGE"
    icon="ri-global-line"
    :title="'d_ws_change_language' | translate"
    width="512"
    :mobile-type="$MODAL_TYPE_MOBILE.FULL"
    :frame="true"
  >
    <div class="language-modal">
      <div class="language-modal__inner">
        <RadioList
          :list="$store.languages"
          :selected="selected"
          :mobile="true"
          @change="change"
        />
      </div>
    </div>
  </RootModalComponent>
</template>

<script>

import RootModalComponent from './RootModalComponent'
import Dropdown from '../controls/Dropdown'
import RadioList from '../controls/RadioList';

export default {
  components: {
    RootModalComponent,
    Dropdown,
    RadioList
  },
  data() {
    return {
      selected: this.$languageService.getLanguage(),
      languages: [],
      languagesForMobile: []
    }
  },
  methods: {
    change(tag) {
      this.selected = tag;

      this.$languageService.changeLanguage(this.selected).then(() => {
        this.$modal.hide(this.$MODAL_NAME.CHANGE_LANGUAGE)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .language-modal {
    display: flex;
    justify-content: center;
    &__inner {
      padding: 24px 40px;
      max-width: 100%;
    }
  }

  @media (max-width: 425px) {
    .language-modal {
      &__inner {
        padding: 8px;
        width: 100%;
      }
    }
  }
</style>
